import TableCard from './TableCard';

export default TableCard;
